import DOMPurify from "dompurify";
import type { TResourceCardProps } from "./types";

export const ResourceCard = ({
  image,
  title,
  description,
}: TResourceCardProps) => {
  const ResourceCardElement = document.createElement("div");
  ResourceCardElement.className = "w-full p-6 flex flex-col gap-6 bg-white";

  ResourceCardElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <img src=${image.src} alt=${image.alt} class="w-8 h-8" />

        <div class="flex flex-col gap-2">
            <h3 class="text-2xl font-medium  text-blue-800">
                ${title}
            </h3>

            <p class="text-xl  text-gray-800">
                ${description}
            </p>
        </div>
    `);

  return ResourceCardElement;
};
